import { AirtableProviderEnrollmentsResponse } from '@berry-street/common';
import { useQuery } from '@tanstack/react-query';
import {
  QUERY_ENROLLMENTS_KEY,
  QUERY_NEW_ENROLLMENTS_KEY,
} from '@web-app/hooks/consts';

const getEnrollments =
  async (): Promise<AirtableProviderEnrollmentsResponse> => {
    try {
      const response = await fetch('/api/user/enrollments');

      if (!response.ok) {
        throw new Error(`${response.status} ${response.statusText}`);
      }

      return response.json();
    } catch (err) {
      console.error('Error getting enrollments', err);
      return {
        states: [],
        enrollments: [],
      };
    }
  };

const getNewEnrollments = async (): Promise<string[]> => {
  try {
    const response = await fetch('/api/user/enrollments?new=true');

    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }

    return response.json();
  } catch (err) {
    console.error('Error getting enrollments', err);
    return [];
  }
};

export const useEnrollments = (isNew?: boolean) => {
  return useQuery({
    queryKey: [isNew ? QUERY_NEW_ENROLLMENTS_KEY : QUERY_ENROLLMENTS_KEY],
    queryFn: () => getEnrollments(),
  });
};

export const useNewEnrollments = () => {
  return useQuery({
    queryKey: [QUERY_NEW_ENROLLMENTS_KEY],
    queryFn: () => getNewEnrollments(),
  });
};
